import { Controller, useForm, useWatch } from 'react-hook-form';
import { ConfirmationBisRowProps, ConfirmationBisRowSchema } from './ConfirmationBisRow.types';
import { yupResolver } from '@hookform/resolvers/yup';
import { getConfirmationBisSchema } from './ConfirmationBisRow.schema';
import { useMemo, useState } from 'react';
import { confirmationBisData } from './ConfirmationBisRow.data';
// import CreatableSelect from '../../../../../../commons/CreatableSelect/CreatableSelect';
import Select from '../../../../../../commons/Select/Select';
import Input from '../../../../../../commons/Input/Input';

export default ({
  NAFList,
  index,
  isLast,
  choosedNAFCodes,
  onChange: onChangeChooseNAFCodes,
  onAdd,
  onRemove,
}: ConfirmationBisRowProps) => {
  const formProps = useForm<ConfirmationBisRowSchema>({
    resolver: yupResolver(getConfirmationBisSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    control,
    formState: { errors, isValid },
  } = formProps;

  const NAFCode = useWatch({
    control,
    name: 'fieldOfActivity',
  });

  const [inputValue, setInputValue] = useState<string>()

  // useEffect(() => {
  //   console.log('inputValue', inputValue)
  // }, [inputValue])

  // useEffect(() => {
  //   if (NAFCode) {
  //     const index = choosedNAFCodes.indexOf(NAFCode)
  //     if (~index) {
  //       choosedNAFCodes[index] = NAFCode;
  //       setChoosedNAFCodes(choosedNAFCodes)
  //     } else {
  //       setChoosedNAFCodes(value => [...value, NAFCode])
  //     }
  //   }
  // }, [choosedNAFCodes, setChoosedNAFCodes, NAFCode])

  const updatedFormData = useMemo(
    () =>
      confirmationBisData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'fieldOfActivity':
              return {
                ...item,
                // disabled: !domain,
                options: [
                  //   {
                  //     value: 'custom',
                  //     label: 'Je ne trouve pas mon domaine'
                  //   },
                  //   ...(NAFList?.filter(
                  //   (item) =>
                  //     domain == item.id_domain?.toString() &&
                  //     !choosedNAFCodes.find(
                  //       (choosedNAF) => choosedNAF?.value === item.NAF_code.toString()
                  //     )
                  // )?.map(({ NAF_code, description }) => ({
                  //   label: description,
                  //   value: NAF_code.toString(),
                  // }))) || [{
                  //   value: 'custom',
                  //   label: 'Je ne trouve pas mon domaine'
                  // }]],
                  ...(NAFList
                    ?.filter((item) => item.description.toLowerCase().includes(inputValue?.toLowerCase() || 'Not in list'))
                    ?.map(({ NAF_code, description }) => ({
                    label: description,
                    value: NAF_code.toString(),
                  })) || [])
                ]
                // ...(choosedNAFCodes[index] && {
                //   value: {
                //     label: choosedNAFCodes[index]?.label,
                //     value: choosedNAFCodes[index]?.value,
                //   },
                // }),
              };
            default:
              return item;
          }
        })
      ),
    [NAFList, inputValue, choosedNAFCodes, index]
  );

  return (
    <div key={`row#${index}`} className="form__row register__confirmation-bis-row">
      {updatedFormData.map((row) =>
        row.map(({ name, placeholder, label, options, onChangeValue, ...props }, inputIndex) => (
          <Controller
            key={`controlledInput#${inputIndex}`}
            name={name}
            render={({ field: { onChange } }) =>
              <div className='flex-column' style={{ flex: 1 }}>
                  <Select
                    key={`${name}#${index}`}
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    onInputChange={(value: string) => setInputValue(value)}
                    {...{ label, options }}
                    {...props}
                    // @ts-ignore
                    onChange={({ value, label }: SelectOption) => {
                      onChangeChooseNAFCodes(index, { value, label });
                      onChange(value);
                      setInputValue(value);
                      if (onChangeValue) {
                        onChangeValue(value);
                      }
                    }}
                    // @ts-ignore
                    noOptionsMessage={({ inputValue }) => !inputValue ? 'Chercher un domaine' : 'Aucun résultat trouvé'}
                  />
                  {NAFCode === 'custom' &&
                    <Input
                      placeholder="Entrez un domaine d'activité"
                      onChange={(e) => {
                        const value = e.target.value
                        onChangeChooseNAFCodes(index, { value, label: value })
                      }}
                    />
                  }
                </div>
            }
            {...{ control }}
          />
        ))
      )}
      {isLast ? (
        <button
          onClick={(e) => {
            e.preventDefault();
            onAdd();
          }}
          disabled={!isValid}>
          +
        </button>
      ) : (
        <button
          onClick={(e) => {
            e.preventDefault();
            onRemove(index);
          }}>
          -
        </button>
      )}
    </div>
  );
};
